import { ImgHTMLAttributes } from "react";
import { Img } from "../HtmlTags/Img/Img";
import logoImg from "../../../assets/images/brandAssets/ZelpyeLogo.png";
import logoOutlineImg from "../../../assets/images/brandAssets/ZelpyeLogoOutline.png";
import textImg from "../../../assets/images/brandAssets/ZelpyeText.png";
import whiteTextLogoImg from "../../../assets/images/brandAssets/ZelpyeWhiteTextLogo.png";
import textLogoImg from "../../../assets/images/brandAssets/ZelpyeTextLogo.png";
import {
  ZELPYE_LOGO_ALT,
  ZELPYE_LOGO_BASE_CLASS,
  ZELPYE_LOGO_VARIANT,
  ZELPYE_LOGO_VARIANT_CLASS,
  ZelpyeLogoVariant,
} from "./ZelpyeLogo.constants";
import "./ZelpyeLogo.css";


const VARIANT_CONFIG: Record<
  ZelpyeLogoVariant,
  { src: string; alt: string; className: string }
> = {
  [ZELPYE_LOGO_VARIANT.LOGO]: {
    src: logoImg,
    alt: ZELPYE_LOGO_ALT[ZELPYE_LOGO_VARIANT.LOGO],
    className: `${ZELPYE_LOGO_BASE_CLASS} ${ZELPYE_LOGO_VARIANT_CLASS[ZELPYE_LOGO_VARIANT.LOGO]}`,
  },
  [ZELPYE_LOGO_VARIANT.LOGO_OUTLINE]: {
    src: logoOutlineImg,
    alt: ZELPYE_LOGO_ALT[ZELPYE_LOGO_VARIANT.LOGO_OUTLINE],
    className: `${ZELPYE_LOGO_BASE_CLASS} ${ZELPYE_LOGO_VARIANT_CLASS[ZELPYE_LOGO_VARIANT.LOGO_OUTLINE]}`,
  },
  [ZELPYE_LOGO_VARIANT.TEXT]: {
    src: textImg,
    alt: ZELPYE_LOGO_ALT[ZELPYE_LOGO_VARIANT.TEXT],
    className: `${ZELPYE_LOGO_BASE_CLASS} ${ZELPYE_LOGO_VARIANT_CLASS[ZELPYE_LOGO_VARIANT.TEXT]}`,
  },
  [ZELPYE_LOGO_VARIANT.TEXT_LOGO]: {
    src: textLogoImg,
    alt: ZELPYE_LOGO_ALT[ZELPYE_LOGO_VARIANT.TEXT_LOGO],
    className: `${ZELPYE_LOGO_BASE_CLASS} ${ZELPYE_LOGO_VARIANT_CLASS[ZELPYE_LOGO_VARIANT.TEXT_LOGO]}`,
  },
  [ZELPYE_LOGO_VARIANT.WHITE_TEXT_LOGO]: {
    src: whiteTextLogoImg,
    alt: ZELPYE_LOGO_ALT[ZELPYE_LOGO_VARIANT.WHITE_TEXT_LOGO],
    className: `${ZELPYE_LOGO_BASE_CLASS} ${ZELPYE_LOGO_VARIANT_CLASS[ZELPYE_LOGO_VARIANT.WHITE_TEXT_LOGO]}`,
  },
};

export type ZelpyeLogoProps = {
  variant: ZelpyeLogoVariant;
  className?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

export const ZelpyeLogo = ({
  variant,
  className,
  ...imgProps
}: ZelpyeLogoProps) => {
  const { src, alt, className: variantClassName } = VARIANT_CONFIG[variant];
  const combinedClassName = [variantClassName, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Img src={src} alt={alt} className={combinedClassName} {...imgProps} />
  );
};

export default ZelpyeLogo;
